import {
  AVATAR_IDS,
  avatarPngUrl,
  avatarVideoUrl,
  avatarWebpUrl,
  isAvatarId,
} from '@redpandev/shared';

/**
 * Helpers d'affichage du catalogue d'avatars (spec 07 §2.3).
 * Toute surface qui montre un avatar passe par `avatarSources()` puis le
 * composant `<Avatar>` de @redpandev/ui : vidéo animée (image `<picture>`
 * webp+png en vignette le temps du chargement), rond, fallback mascotte.
 * Jamais d'URL construite à la main.
 */

export type AvatarSources = { src: string; webpSrc: string; videoSrc: string };

/**
 * Props média pour `<Avatar>` à partir d'un id du catalogue.
 * `null`/`undefined`/id inconnu → `undefined` (l'Avatar retombe sur la mascotte).
 */
export function avatarSources(avatarId: string | null | undefined): AvatarSources | undefined {
  if (!avatarId || !isAvatarId(avatarId)) return undefined;
  return {
    src: avatarPngUrl(avatarId),
    webpSrc: avatarWebpUrl(avatarId),
    videoSrc: avatarVideoUrl(avatarId),
  };
}

/** Tirage au sort d'un id (présélection fun à l'inscription — purement client). */
export function randomAvatarId(): string {
  const id = AVATAR_IDS[Math.floor(Math.random() * AVATAR_IDS.length)];
  // AVATAR_IDS n'est jamais vide (catalogue embarqué) — repli défensif.
  return id ?? AVATAR_IDS[0]!;
}
